<template>
  <div class="balance-recharge">
    <pageHeader title="余额充值" >
      <template v-slot:headerRight>
        <div class="icon-item" @click="customerDialogVirsble = true">
          <img src="@/assets/images/ic_customer_one.png" alt="" />
          <span>客服</span>
        </div>
      </template>
    </pageHeader>

    <div class="gray-box"></div>

    <div class="recharge-amount">
      <h1>选择充值金额<em class="title-desc-em">（*余额不可退现）</em></h1>
      <div class="recharge-box">
        <div
          @click="amountClick(item, i)"
          :class="[
            'recharge-item',
            currentIndex == i ? 'recharge-actived-item' : '',
          ]"
          v-for="(item, i) in amountList"
          :key="i"
        >
          <span>{{ item.amount }}元</span>
          <span>{{ item.label }}</span>
        </div>
      </div>

      <div class="amount-input">
        <van-field
          v-model="amountNumber"
          type="number"
          placeholder="请输入金额"
          input-align="center"
        ></van-field>
      </div>
    </div>

    <div class="recharge-payway">
      <h1>选择支付方式</h1>

      <div class="payway-box">
        <div
          class="payway-item"
          @click="chosePayWay(item, i)"
          v-for="(item, i) in payList"
          :key="i"
        >
          <div class="payway-info">
            <img :src="item.icon" alt="" />
            <span>{{ item.label }}</span>
          </div>
          <img
            class="status-chose"
            src="@/assets/images/ic_status_grey.png"
            alt=""
            v-if="payway != item.id"
          />
          <img
            v-else
            class="status-chose"
            src="@/assets/images/ic_status_ok2.png"
            alt=""
          />
        </div>
      </div>
    </div>

    <div class="recharge-btn">
      <!-- <van-button :color="rechargeColor" @click="recharge"> 确认充值 </van-button> -->
      <van-button
          :color="rechargeColor"
          :text="loading ? '正在跳转' : '确认充值'"
          :disabled="loading"
          @click="handlepay"
        ></van-button>
    </div>

    <customerDialog
      v-if="customerDialogVirsble"
      v-model="customerDialogVirsble"
      @handleClose="dialogClose"
    />
  </div>
</template>

<script>
import pageHeader from "@/components/PageHeader";
import customerDialog from "@/components/CustomerDialog";
import { requestMethods } from "@m/api";
import { mapGetters } from "vuex";
export default {
  components: {
    pageHeader,
    customerDialog
  },
  data() {
    return {
      customerDialogVirsble: false,
      amountNumber: "",
      amountList: [
        {
          amount: "100",
          label: "推荐",
        },
        {
          amount: "300",
          label: "推荐",
        },
        {
          amount: "500",
          label: "推荐",
        },
        {
          amount: "1000",
          label: "推荐",
        },
        {
          amount: "2000",
          label: "推荐",
        },
        {
          amount: "5000",
          label: "推荐",
        },
      ],
      currentIndex: "-1",
      payList: [
        {
          label: "支付宝支付",
          icon: require("@/assets/images/ic_ali_pay.png"),
          id: 'lipay'
        },
        // {
        //   label: "微信支付",
        //   icon: require("@/assets/images/ic_share_wechat.png"),
        //   id: 'wechat'
        // }
      ],
      payway: 'lipay',
      loading: false
    };
  },
  computed: {
    ...mapGetters(["uuid"]),
    rechargeColor() {
      if(this.payway && this.amountNumber) {
        return '#FF7A3E'
      } else {
        return '#E6E6E6'
      }
    },
  },
  methods: {
    dialogClose(action, done) {
      done()
    },
    amountClick(item, index) {
      this.amountNumber = item.amount;
      this.currentIndex = index;
    },

    chosePayWay(item, index) {
      this.payway = item.id;
    },
    // 充值
    handlepay() {
      localStorage.setItem('payRouter', JSON.stringify('balance'))
      if(this.payway == 'lipay') {
        this.loading = true
        this.aliPaySubmit();
      }
    },
    async aliPaySubmit() {
      try {
        const { data } = await requestMethods(
          "/modules/RechargeAction/doBalanceRecharge.htm",
          "post",
          {
            amount: this.amountNumber,
            uuid: this.uuid,
            payWay: "alipay_h5"
          }
        );
        const { body } = data.orderInfo;
        this.submitForm(body);
      } catch (err) {
        this.$toast(err.message);
      }
    },
    submitForm(formHtml) {
      const div = document.createElement("div");
      div.innerHTML = formHtml; // 将HTML表单插入到div中
      document.body.appendChild(div); // 将div添加到body中
      const form = div.querySelector("form"); // 查找插入的表单
      if (form) {
        form.submit(); // 自动提交表单
      } else {
        console.error("未找到表单");
        this.loading = false; // 重置按钮状态
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.balance-recharge {
  .page-right {
    display: flex;
    align-items: center;

    .icon-item {
      display: flex;
      align-items: flex-end;
      margin-right: 8px;

      img {
        width: 30px;
        height: 30px;
        margin-right: 6px;
      }
      span {
        color: #8f8f8f;
      }
    }
  }
  .gray-box {
    width: 100%;
    height: 20px;
    background: #f5f5f5;
  }
  .recharge-amount {
    padding: 35px 30px;

    h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #212121;
      line-height: 45px;
      margin-bottom: 30px;
      margin-left: 5px;
    }

    .title-desc-em {
      font-weight: 500;
      font-size: 24px;
      color: #212121;
    }
    .recharge-box {
      display: flex;
      flex-wrap: wrap;

      .recharge-item {
        width: 220px;
        height: 150px;
        border-radius: 16px;
        border: 2px solid #bbbbbb;
        margin: 5px;
        text-align: center;
        padding-top: 30px;

        span {
          display: block;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          font-size: 30px;
          color: #212121;
          line-height: 42px;

          &:last-child {
            font-weight: 400;
            font-size: 26px;
            color: #8f8f8f;
            margin-top: 10px;
          }
        }
      }
      .recharge-actived-item {
        background: #ffeee3;
        border: 2px solid #ffcdac;
      }
    }
    .amount-input .van-field {
      width: 680px;
      height: 80px;
      background: #e6e6e6;
      border-radius: 40px;
      margin-top: 40px;
    }
  }

  .recharge-payway {
    padding: 35px;
    h1 {
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 32px;
      color: #212121;
      line-height: 45px;
    }

    .payway-box {
      .payway-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 30px;

        .status-chose {
          width: 40px;
          height: 40px;
        }
        .payway-info {
          display: flex;
          align-items: center;

          img {
            width: 80px;
            height: 80px;
            margin-right: 36px;
          }
          span {
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            font-size: 28px;
            color: #212121;
            line-height: 40px;
          }
        }
      }
    }
  }
  .recharge-btn {
    width: 680px;
    height: 80px;
    position: fixed;
    bottom: 30px;
    left: 35px;

    .van-button {
      height: 80px;
      border-radius: 40px;
      width: 680px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/balanceRecharge/index.vue